import React from "react";
import "./SampleVideos.css";

const SampleVideos = () => {
  const videos = [
    { id: 1, src: "/videos/videosample1.mp4", poster: "/videos/videosample1.jpg" },
    { id: 2, src: "/videos/videosample2.mp4", poster: "/videos/videosample2.jpg" },
    { id: 3, src: "/videos/videosample3.mp4", poster: "/videos/videosample3.jpg" },
    { id: 5, src: "/videos/videosample5.mp4", poster: "/videos/videosample5.jpg" },
  ];

  return (
    <section className="sample-videos">
      <div className="sample-videos-container">
        <h2 className="section-title">Sample Videos</h2>
        <p className="section-subtitle">
          Here's are examples of the types of video we want created
        </p>
        <p className="video-disclaimer">
          These examples are for inspiration only.
          <br />
          Please do not replicate word-for-word or frame-for-frame.
        </p>
        <div className="videos-grid">
          {videos.map((video) => (
            <div key={video.id} className="video-card">
              <video
                controls
                preload="metadata"
                playsInline
                webkit-playsinline="true"
                className="video-player"
                poster={video.poster}
              >
                <source src={video.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
        <div className="content-guidelines">
          <h3>Content Style Guidelines</h3>
          <ul>
            <li>60–90s vertical videos</li>
            <li>Shot on phone in a real kitchen or home</li>
            <li>Casual, honest delivery (no "ad voice")</li>
            <li>POV or waist-up framing</li>
            <li>Show the pours and final drink</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SampleVideos;
